<template>
    <div id="new-firm-form">
        <div class="row">
            <div class="col-12">
                <transition name="fade">
                    <FormWizardFirmSearch v-if="currentStep === 'search'" />
                </transition>
                <transition name="fade">
                    <FormWizardFirmClaim v-if="currentStep === 'claim'" />
                </transition>
                <transition name="fade">
                    <FormWizardFirmRegister v-if="currentStep === 'register'" />
                </transition>
                <transition name="fade">
                    <FormWizardFirmPresentation
                        v-if="currentStep === 'presentation'"
                    />
                </transition>
                <transition name="fade">
                    <FormWizardFirmGopay v-if="currentStep === 'gopay'" />
                </transition>
                <transition name="fade">
                    <FormWizardFirmNopay v-if="currentStep === 'nopay'" />
                </transition>
            </div>
        </div>
        <notification-loader />
    </div>
</template>

<script>
import FormWizardFirmSearch from './partials/FormWizardFirmSearch'
import FormWizardFirmClaim from './partials/FormWizardFirmClaim'
import FormWizardFirmRegister from './partials/FormWizardFirmRegister'
import FormWizardFirmPresentation from './partials/FormWizardFirmPresentation'
import FormWizardFirmGopay from './partials/FormWizardFirmGopay'
import FormWizardFirmNopay from './partials/FormWizardFirmNopay'
import NotificationLoader from '../NotificationLoader'

export default {
    name: 'FormWizard',
    components: {
        FormWizardFirmSearch,
        FormWizardFirmClaim,
        FormWizardFirmRegister,
        FormWizardFirmPresentation,
        FormWizardFirmGopay,
        FormWizardFirmNopay,
        //FormWizardFirmSave,
        NotificationLoader,
    },
    data() {
        return {
            id_firmy_claim: null,
        }
    },
    computed: {
        currentStep() {
            return this.$store.state.step.currentStep
        },
    },
    methods: {
        onCancel() {
            console.log('User cancelled the loader.')
        },
        fillUpDataSandbox() {
            console.log('fillUpDataSandbox', 'naplnuju store sandboxem')

            this.$store.commit('search/setSearchText', '69558531')

            this.$store.commit('user/setUserFirms', {
                firmy: [
                    {
                        id_firmy: '5000000',
                        '0': '5000000',
                        nazev_firmy: 'Zkouška Registračního Formuláře',
                        '1': 'Zkouška Registračního Formuláře',
                        balicek: '1',
                        '2': '1',
                        id_privilegia: '4',
                        '3': '4',
                        makler: '0',
                        '4': '0',
                        okres_nazev: 'Hodonín',
                        '5': 'Hodonín',
                        obec_nazev: 'Hodonín',
                        '6': 'Hodonín',
                        adresar: 'test-export',
                        '7': 'test-export',
                        rk: '0',
                        '8': '0',
                        blokovany: '0',
                        '9': '0',
                        souhlas_udelen: '2018-01-31 10:39:38',
                        '10': '2018-01-31 10:39:38',
                        souhlas_odvolan: '2018-01-31 07:30:06',
                        '11': '2018-01-31 07:30:06',
                        region: '0000010',
                        '12': '0000010',
                        akce: '3',
                        '13': '3',
                        typovedomy: '10',
                        '14': '10',
                        limit_banneru: '0',
                        '15': '0',
                        limit_clanky: '0',
                        '16': '0',
                        limit_clanky_sponzor: '0',
                        '17': '0',
                        limit_foto: '50',
                        '18': '50',
                        limit_kariera: '0',
                        '19': '0',
                        limit_infomail_clanku: '0',
                        '20': '0',
                        limit_novinky_sortiment: '0',
                        '21': '0',
                        limit_infomail_logo: '0',
                        '22': '0',
                        limit_intext: '0',
                        '23': '0',
                        limit_slogany: '0',
                        '24': '0',
                        limit_partner_oboru: '0',
                        '25': '0',
                        limit_produkty: '0',
                        '26': '0',
                        limit_paticka_logo: '0',
                        '27': '0',
                        limit_paticka_text: '0',
                        '28': '0',
                        limit_pujcovna: '0',
                        '29': '0',
                        limit_tiskove_zpravy: '0',
                        '30': '0',
                        limit_zbozi: '0',
                        '31': '0',
                        limit_novostavby: '0',
                        '32': '0',
                        opravny_kod: '2d99532ba898b61754bee9649',
                        '33': '2d99532ba898b61754bee9649',
                    },
                ],
            })

            this.$store.commit('user/setUser', {
                user_id: '321525',
                token: '99c71b9d02a0d237ecbd15777b74341d',
                email: 'petr.klimes@ci.cz',
                tel1: '603193977',
            })

            this.$store.commit(
                'firm/setFormData',
                {
                    email: 'petr.klimes@ci.cz',
                    telefon: '603193977',
                    www: 'https://www.b2x.cz',
                    popis: 'test smazat',
                },
                { root: true }
            )

            this.$store.commit('firm/setAresData', {
                ico: '69558531',
                dic: 'CY8010181344',
                firma: 'TEST Petr Klimeš',
                ulice: 'Nerudova',
                cislo: '972/12',
                mesto: 'České Budějovice',
                psc: '37004',
            })
            /*
            this.$store.commit('presentations/setPresentations', [
                {
                    "id": "1",
                    "name": "Zápis zdarma",
                    "price_per_year": "0",
                    "active": "0",
                    "services": "Základní zápis;1 kategorie;Bez přednostního umístění;4 fotografie;Neaktivní prolink na www",
                    "button_value": "Pokračovat zdarma"
                },
                {
                    "id": "2",
                    "name": "Placený zápis",
                    "price_per_year": "1250",
                    "active": "1",
                    "services": "Přednostní zápis;1 kategorie;Umístění před konkurencí;50 fotografií;4 videa;Aktivní prolink na www;Logo firmy;Servisní podpora",
                    "button_value": "Pokračovat"
                },
                {
                    "id": "3",
                    "name": "Na plno",
                    "price_per_year": "0",
                    "active": "0",
                    "services": "Přednostní zápis;\r\nNeomezený katalog firem;\r\nUmístění na prvních stranách;\r\nFotoinspirace;\r\nAktivní prolink na www;\r\nLogo firmy;\r\nServisní podpora;\r\nPR články;\r\nVideo články;\r\nSociální sítě;\r\nBannery;\r\nTypové domy;\r\nPartneství oboru;\r\na jiné...",
                    "button_value": "Chci nabídku"
                }
            ])
*/
            this.$store.commit('firm/setPresentation', 2)

            this.$store.commit('firm/setResult', {
                id_firmy: '5000000',
                hashid: 'blablabla',
                id_uzivatele: '321525',
                hashuid: '',
                opravny_kod: '2d99532ba898b61754bee9649',
            })

            this.$store.commit('step/setStep', 'presentation', { root: true })
        },
    },
}
</script>

<style lang="scss">
.slide-leave-active,
.slide-enter-active {
    transition: 1s;
}
.slide-enter {
    transform: translate(100%, 0);
}
.slide-leave-to {
    transform: translate(-100%, 0);
}
</style>
